import { z } from 'zod/v3'
import { createFileRoute } from '@tanstack/react-router'
import { paginationSearchSchema } from '@/lib/pagination'

const riskSearchSchema = paginationSearchSchema.extend({
  run: z.string().optional(),
  tab: z.enum(['register', 'insights', 'snapshots', 'assessments']).optional(),
})

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/risks'
)({
  validateSearch: riskSearchSchema,
  staticData: { pageHeader: { title: 'Risk Register', pad: false } },
})
